import {
  House,
  UserPen,
  UserRoundPlus,
  Users,
  UserRoundX,
  ClockPlus,
  Upload,
  FileUp,
  FileStack,
  FileSpreadsheet,
  SquarePlus,
  InspectionPanel,
} from "lucide-react";
import useSidebarPermissions from "./useSidebarPermissions";
import expense from "../assets/icons/expense.svg";
import addExpenseIcon from "../assets/icons/addExpenseIcon.svg";
import expensesIcon from "../assets/icons/expensesIcon.svg";
import pendingIcon from "../assets/icons/pendingIcon.svg";
import complaint from "../assets/icons/complaint.svg";
import complaints from "../assets/icons/complaints.svg";
import sites from "../assets/icons/sites.svg";
import visits from "../assets/icons/visits.svg";
import user from "../assets/icons/user.svg";
import compPending from "../assets/icons/complaintPending.svg";
import visitPending from "../assets/icons/visitPending.svg";
import officer from "../assets/icons/officer.svg";
import UsersLogs from "../assets/icons/User Logs.svg";
import siteManager from "../assets/icons/siteManager.svg";
import siteHierarchy from "../assets/icons/siteHierarchy.svg";
import siteAdd from "../assets/icons/siteAdd.svg";
import updateBulkSite from "../assets/icons/Update Bulk Site.svg";
import addComp from "../assets/icons/addComp.svg";
import expenseSheet from "../assets/icons/expenseSheet.svg";
import machines from "../assets/icons/machines.svg";
import addMachine from "../assets/icons/addMachine.svg";
import addMachineComp from "../assets/icons/addMachineComponent.svg";
import expenseHistory from "../assets//icons/expenseHistory.svg";
import cylinderTracking from "../assets/icons/cylinder tracking.svg";
import cylinderRegistration from "../assets/icons/cylinderRegistration.svg";
import cylinders from "../assets/icons/cylinders.svg";
import addVehicle from "../assets/icons/add vehicle.svg";
import cylinderHistory from "../assets/icons/cylinder history.svg";
import factoryICon from "../assets/icons/factoryMenuIcon.svg";
import jobCard from "../assets/icons/jobcard.svg";
import cylinderPrediction from "../assets/icons/Cylinder Prediction.svg";
import operationLogs from "../assets/icons/Operational Logs.svg";
import JobCardUpdate from "../assets/icons/Job Card Update .svg";
import JobCardUpdateHistory from "../assets/icons/Job Card Update History .svg";
import discardedCylinder from "../assets/icons/Discarded Cylinder.svg";
import unvisitedSite from "../assets/icons/Unvisited Sites .svg";
import CylinderTransit from "../assets/icons/Cylinder Transit icon.svg";
import jobcardHistory from "../assets/icons/Job_Card_History.svg";
import updateSalaries from "../assets/icons/Update Salaries.svg";
import visitReport from "../assets/icons/Visit report.svg";
import visitReportCylinderChange from "../assets/icons/Visit Report Cylinder change.svg";
import recieverRejected from "../assets/icons/Reciver rejected expense.svg";
import addStationRepair from "../assets/icons/add station repair.svg";
import stationRepairs from "../assets/icons/station repairs.svg";
import deactivatedSites from "../assets/icons/Deactivated sites.svg";
import addVehicleReading from "../assets/icons/Add vehicle reading.svg";
import vehicleReading from "../assets/icons/Vehicle reading.svg";
import pendingVehicleReading from "../assets/icons/Pending vehicle reading.svg";

export const useMenuList = () => {
  const { subMenuPermMap, mainMenuPermMap } = useSidebarPermissions();
  const menuList = [
    {
      menuTitle: "dashboard",
      lucideIcon: House,
      route: "/home",
      isPerm: true,
    },
    {
      menuTitle: "user",
      menuIcon: user,
      height: "h-50",
      isPerm: mainMenuPermMap.user,
      subMenu: [
        {
          menuTitle: "Add User",
          route: "/user/add",
          lucideIcon: UserRoundPlus,
          isPerm: subMenuPermMap.add_user,
        },
        {
          menuTitle: "Users",
          route: "/user/all",
          lucideIcon: Users,
          isPerm: subMenuPermMap.view_user,
        },
        {
          menuTitle: "Add Officer",
          route: "/user/add-officer",
          lucideIcon: UserRoundPlus,
          isPerm: subMenuPermMap.add_officer,
        },
        {
          menuTitle: "Officers",
          route: "/officer/all",
          menuIcon: officer,
          isPerm: subMenuPermMap.view_officer,
        },
        {
          menuTitle: "Disabled Users",
          route: "/user/disable-list",
          lucideIcon: UserRoundX,
          isPerm: subMenuPermMap.disable_user,
        },
        {
          menuTitle: "Users' Activities",
          route: "/user/activity-logs",
          menuIcon: UsersLogs,
          isPerm: subMenuPermMap.users_logs,
        },
        {
          menuTitle: "Update Salaries",
          route: "/user/update-salaries",
          menuIcon: updateSalaries,
          isPerm: subMenuPermMap.update_user,
        },
        {
          menuTitle: "Update Bulk User",
          route: "/update-bulk-user",
          lucideIcon: UserPen,
          isPerm: subMenuPermMap.update_user,
        },
      ],
    },
    {
      menuTitle: "expense",
      menuIcon: expense,
      height: "h-50",
      isPerm: true,
      subMenu: [
        {
          menuTitle: "Add Expense",
          route: "/expense/add",
          menuIcon: addExpenseIcon,
          isPerm: subMenuPermMap.add_expense,
        },
        {
          menuTitle: "Expense",
          route: "/expense/all",
          menuIcon: expensesIcon,
          isPerm: true,
        },
        {
          menuTitle: "Receiver Pending",
          route: "/expense/receiver-pending",
          menuIcon: pendingIcon,
          isPerm: true,
        },
        {
          menuTitle: "Supervisor Pending",
          route: "/expense/supervisor-pending",
          menuIcon: pendingIcon,
          isPerm: subMenuPermMap.sup_check,
        },
        {
          menuTitle: "Admin Pending",
          route: "/expense/admin-pending",
          menuIcon: pendingIcon,
          isPerm: subMenuPermMap.admin_check,
        },
        {
          menuTitle: "Super Admin Pending",
          route: "/expense/super-admin-pending",
          menuIcon: pendingIcon,
          isPerm: subMenuPermMap.sup_admin_check,
        },
        {
          menuTitle: "Check History",
          route: "/expense/check-history",
          menuIcon: expenseHistory,
          isPerm: subMenuPermMap.check_history,
        },
        {
          menuTitle: "Expense History",
          route: "/expense/history",
          menuIcon: expenseHistory,
          isPerm: subMenuPermMap.add_expense,
        },
        {
          menuTitle: "Add Overtime",
          route: "/expense/add-overtime",
          lucideIcon: ClockPlus,
          isPerm: subMenuPermMap.add_overtime,
        },
        {
          menuTitle: "Rejected Company Expenses",
          route: "/expense/receiver-rejected",
          menuIcon: recieverRejected,
          isPerm: subMenuPermMap.view_receiver_rejected_company_expense,
        },
      ],
    },
    {
      menuTitle: "Maintenance",
      menuIcon: complaint,
      height: "h-50",
      isPerm: mainMenuPermMap.maintenance,
      subMenu: [
        {
          menuTitle: "Add Complaint",
          route: "/complaint/add",
          menuIcon: addComp,
          isPerm: subMenuPermMap.add_complaint,
        },
        {
          menuTitle: "Complaints",
          route: "/complaint/all",
          menuIcon: complaints,
          isPerm: subMenuPermMap.view_complaint,
        },
        {
          menuTitle: "Complaint Pending",
          route: "/complaint/pending",
          menuIcon: compPending,
          isPerm: subMenuPermMap.resolve_complaint,
        },
        {
          menuTitle: "Add Visit",
          route: "/complaint/add-visit",
          menuIcon: visits,
          isPerm: subMenuPermMap.add_visit,
        },
        {
          menuTitle: "Visits",
          route: "/complaint/visit-all",
          menuIcon: visits,
          isPerm: subMenuPermMap.view_visit,
        },
        {
          menuTitle: "Visit Pending",
          route: "/complaint/visit-pending",
          menuIcon: visitPending,
          isPerm: subMenuPermMap.check_visit,
        },
        {
          menuTitle: "Sites visit Report",
          route: "/complaint/download-visit-report",
          menuIcon: visitReport,
          isPerm: subMenuPermMap.view_site,
        },
        {
          menuTitle: "Cylinder Change Visit Report",
          route: "/complaint/visit-cylinder-change-report",
          menuIcon: visitReportCylinderChange,
          isPerm: subMenuPermMap.view_visit,
        },
        {
          menuTitle: "Add Vehicle Reading",
          route: "/add-vehicle-reading",
          menuIcon: addVehicleReading,
          isPerm: subMenuPermMap.add_vehicle_reading,
        },
        {
          menuTitle: "Vehicle Readings",
          route: "/vehicle-readings",
          menuIcon: vehicleReading,
          isPerm: subMenuPermMap.all_vehicle_readings,
        },
        {
          menuTitle: "Pending Vehicle Readings",
          route: "/pending-vehicle-readings",
          menuIcon: pendingVehicleReading,
          isPerm: subMenuPermMap.pending_vehicle_readings,
        },
        {
          menuTitle: "Add Station Repair",
          route: "/site/add-repair-work",
          menuIcon: addStationRepair,
          isPerm: subMenuPermMap.station_repair,
        },
        {
          menuTitle: "Station Repair",
          route: "/site/repair-work",
          menuIcon: stationRepairs,
          isPerm: subMenuPermMap.station_repair,
        },
        {
          menuTitle: "Add Material",
          route: "/add-material",
          lucideIcon: SquarePlus,
          isPerm: subMenuPermMap.add_material_transport,
        },
        {
          menuTitle: "Material Transport History",
          route: "/material-transport-history",
          lucideIcon: InspectionPanel,
          isPerm: subMenuPermMap.view_material_transport,
        },
        {
          menuTitle: "Unvisited Sites",
          route: "/site/unvisited",
          menuIcon: unvisitedSite,
          isPerm: subMenuPermMap.view_site,
        },
      ],
    },
    {
      menuTitle: "Site Manager",
      menuIcon: siteManager,
      height: "h-50",
      isPerm: mainMenuPermMap.site_manager,
      subMenu: [
        {
          menuTitle: "Add Site",
          route: "/site/add",
          menuIcon: siteAdd,
          isPerm: subMenuPermMap.add_site,
        },
        {
          menuTitle: "Sites",
          route: "/site/all",
          menuIcon: sites,
          isPerm: subMenuPermMap.view_site,
        },
        {
          menuTitle: "Update Bulk Sites",
          route: "/site/update-bulk",
          menuIcon: updateBulkSite,
          isPerm: subMenuPermMap.add_site,
        },
        {
          menuTitle: "Add Jurisdiction",
          route: "/site/add-jurisdiction",
          menuIcon: siteHierarchy,
          isPerm: subMenuPermMap.add_hier,
        },
        {
          menuTitle: "Assign Machine",
          route: "/site/assign-machine",
          menuIcon: addMachine,
          isPerm: subMenuPermMap.assign_machine,
        },
        {
          menuTitle: "Add Machine",
          route: "/site/add-machine",
          menuIcon: addMachine,
          isPerm: subMenuPermMap.add_machine,
        },
        {
          menuTitle: "Machines",
          route: "/site/all-machine",
          menuIcon: machines,
          isPerm: subMenuPermMap.view_machine,
        },
        {
          menuTitle: "Add Machine Component",
          route: "/site/add-machine-component",
          menuIcon: addMachineComp,
          isPerm: subMenuPermMap.add_machine_component,
        },
        {
          menuTitle: "Deactivated Sites",
          route: "/deactivated-sites",
          menuIcon: deactivatedSites,
          isPerm: subMenuPermMap.view_site,
        },
      ],
    },
    {
      menuTitle: "Expense Sheet",
      menuIcon: expenseSheet,
      height: "h-50",
      isPerm: mainMenuPermMap.expense_sheet,
      subMenu: [
        {
          menuTitle: "Upload Sheets",
          route: "/sheet/add",
          lucideIcon: Upload,
          isPerm: subMenuPermMap.add_sheets,
        },
        {
          menuTitle: "Uploaded Sheets List",
          route: "/sheet/uploaded-all",
          lucideIcon: FileUp,
          isPerm: subMenuPermMap.view_sheets,
        },
        {
          menuTitle: "Generated Monthly Sheet",
          route: "/sheet/generated-monthly",
          lucideIcon: FileStack,
          isPerm: subMenuPermMap.view_generated_sheets,
        },
      ],
    },
    {
      menuTitle: "cylinder tracking",
      menuIcon: cylinderTracking,
      height: "h-50",
      isPerm: mainMenuPermMap.cylinder_tracking,
      subMenu: [
        {
          menuTitle: "Register Cylinder",
          route: "/cylinder/registered",
          menuIcon: cylinderRegistration,
          isPerm: subMenuPermMap.register_cylinder,
        },
        {
          menuTitle: "Cylinders",
          route: "/sites/cylinders",
          menuIcon: cylinders,
          isPerm: subMenuPermMap.view_cylinder,
        },
        {
          menuTitle: "Cylinders In-transit",
          route: "/cylinders/transit",
          menuIcon: CylinderTransit,
          isPerm: subMenuPermMap.view_cylinder,
        },
        {
          menuTitle: "Cylinders Prediction",
          route: "/sites/cylinder-prediction",
          menuIcon: cylinderPrediction,
          isPerm: subMenuPermMap.cylinder_prediction,
        },
        {
          menuTitle: "Cylinder History",
          route: "/cylinder/history",
          menuIcon: cylinderHistory,
          isPerm: subMenuPermMap.view_cylinder,
        },
        {
          menuTitle: "Add Vehicle",
          route: "/cylinder/add-vehicle",
          menuIcon: addVehicle,
          isPerm: subMenuPermMap.dispatch_cylinder,
        },
        {
          menuTitle: "Operational Logs",
          route: "/cylinder/operational-logs",
          menuIcon: operationLogs,
          isPerm: subMenuPermMap.cylinder_prediction,
        },
        {
          menuTitle: "Discarded Cylinders",
          route: "/discarded/Cylinders",
          menuIcon: discardedCylinder,
          isPerm: subMenuPermMap.discarded_cylinders,
        },
      ],
    },
    {
      menuTitle: "Factory",
      menuIcon: factoryICon,
      height: "h-50",
      isPerm: mainMenuPermMap.factory,
      subMenu: [
        {
          menuTitle: "Cylinder Job Card",
          route: "/factory/add-job-card",
          menuIcon: jobCard,
          isPerm: subMenuPermMap.add_job_card,
        },
        {
          menuTitle: "Cylinder Job card Updates",
          route: "/factory/cylinder-jobcard-updates",
          menuIcon: JobCardUpdate,
          isPerm: subMenuPermMap.checkpoint_inform,
        },
        {
          menuTitle: "Cylinder Job card Updates History",
          route: "/factory/cylinder-jobcard-updates-history",
          menuIcon: JobCardUpdateHistory,
          isPerm: subMenuPermMap.checkpoint_inform,
        },
        {
          menuTitle: "Job Card History",
          route: "/factory/jobcard-history",
          menuIcon: jobcardHistory,
          isPerm: subMenuPermMap.job_card_history,
        },
        {
          menuTitle: "Job Card Report",
          route: "/factory/jobcard-report",
          lucideIcon: FileSpreadsheet,
          isPerm: subMenuPermMap.job_card_history,
        },
      ],
    },
  ];

  return menuList;
};
